import { render, staticRenderFns } from "./pp-grab.vue?vue&type=template&id=66fe0e24&lang=html&"
import script from "./pp-grab.vue?vue&type=script&lang=js&"
export * from "./pp-grab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports